module.exports = __webpack_public_path__ + "static/75-cd06307ec602ba92b88aab29deb86b3e.jpeg";